import { LordIcon } from "@/shared/components/ui/lord-icon";

export function AddressNotServedAlert() {
  return (
    <div className="w-full bg-red-50 border border-red-200 rounded-lg p-3">
      <div className="flex items-center gap-2">
        <LordIcon src="/lordicons/warning.json" trigger="in" className="w-6 h-6" colors="#dc2626" />
        <p className="text-xs text-red-700 flex-1">
          Este restaurante não entrega no endereço selecionado
        </p>
      </div>
    </div>
  );
}
